import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
var Auth = function (_a) {
    var hasPermission = _a.hasPermission;
    var location = useLocation();
    return hasPermission() ? (_jsx(Suspense, { children: _jsx(Outlet, {}) })) : (_jsx(Navigate, { to: "/404", state: { from: location }, replace: true }));
};
export default Auth;
